import { render } from "./CreateCompanyWizardActions.vue?vue&type=template&id=6331eb79"
import script from "./CreateCompanyWizardActions.vue?vue&type=script&lang=js"
export * from "./CreateCompanyWizardActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__